import { useEffect, useState } from "react";
import { adminApi, formatApiError } from "@/admin/api";
import PageHeader from "@/admin/components/PageHeader";
import { toast } from "sonner";

export default function FreeTrialsPage() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState(0);

  const load = async () => {
    try {
      const { data } = await adminApi.get("/free-trials", { params: { skip, limit: 50 } });
      setItems(data.items || []);
      setTotal(data.total || 0);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || e.message);
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [skip]);

  return (
    <div data-testid="admin-free-trials-page">
      <PageHeader eyebrow="Inbox" title="Free trial requests" description="Sample-data uploads from the /free-trial page." />
      <div className="p-8">
        <div className="bg-white border border-zinc-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 text-left">
              <tr className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
                <th className="p-3">Received</th>
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Company</th>
                <th className="p-3">Service</th>
                <th className="p-3">File</th>
                <th className="p-3">Description</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-200">
              {items.map((c) => (
                <tr key={c.id} className="hover:bg-zinc-50 align-top">
                  <td className="p-3 text-[11px] font-mono text-zinc-500">{new Date(c.created_at).toLocaleString()}</td>
                  <td className="p-3 font-medium text-zinc-900">{c.name}</td>
                  <td className="p-3 text-zinc-700">{c.email}</td>
                  <td className="p-3 text-zinc-700">{c.company || "—"}</td>
                  <td className="p-3 text-xs font-mono">{c.service_type || "—"}</td>
                  <td className="p-3 text-xs">
                    {c.file_name ? (
                      <>
                        <div className="font-medium text-zinc-900">{c.file_name}</div>
                        <div className="text-[11px] font-mono text-zinc-500">{(c.file_size / 1024).toFixed(1)} KB</div>
                      </>
                    ) : "—"}
                  </td>
                  <td className="p-3 text-xs text-zinc-600 max-w-sm truncate" title={c.project_description || ""}>{c.project_description || "—"}</td>
                </tr>
              ))}
              {!items.length && (
                <tr><td colSpan={7} className="p-10 text-center text-zinc-500 text-sm">No free-trial submissions yet.</td></tr>
              )}
            </tbody>
          </table>
          <div className="p-3 border-t border-zinc-200 flex items-center justify-between text-xs font-mono text-zinc-600">
            <span>{total} total · showing {items.length}</span>
            <div className="flex gap-2">
              <button disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - 50))} className="px-3 py-1 border border-zinc-300 disabled:opacity-40">Prev</button>
              <button disabled={skip + items.length >= total} onClick={() => setSkip(skip + 50)} className="px-3 py-1 border border-zinc-300 disabled:opacity-40">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
